import React from "react"
import { useGlobalContext } from "./context"
import  Search from "./Search"
import Movies from "./Movies"

const Home=()=>{
 
    return <div>
        <Search/>
        <Movies/>
    </div>
}

export default Home